import type { GetUsersParams } from '@lib/types/users'
import type { PaginatedData } from '@lib/types/paginatedData'
import type { User } from '@openapi'
import { ADMIN_API_METHOD_TYPES } from '@lib/sdk/api/modules/admin/types.admin'
import { usePostRobot } from '@lib/sdk/utils/postrobot'

/**
 * Fetches a list of users from the admin API.
 *
 * @param payload - Optional parameters for filtering users
 * @returns Promise resolving to a paginated list of users
 *
 * @example
 * const adminApi = useAdmin()
 * const users = await adminApi.getUsers({ page_size: 100 })
 */
export async function getUsers(payload?: GetUsersParams): Promise<PaginatedData<User>> {
  const pr = await usePostRobot()
  const response = await pr.send(window.parent, ADMIN_API_METHOD_TYPES.GET_USERS, payload)
  return response.data as PaginatedData<User>
}
